import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FeatureFlag {
  applicationName: string;
  configurationName: string;
  flagName: string;
  isEnabled: boolean;
}

export interface FeatureFlagState {
  flags: FeatureFlag[];
}

/**
 * FeatureFlagSliceState
 */
export interface FeatureFlagSliceState {
  featureFlags: FeatureFlagState;
}

export const featureFlagInitialState: FeatureFlagState = {
  flags: [],
};

const featureFlagSlice = createSlice({
  name: 'featureFlag',
  initialState: featureFlagInitialState,
  reducers: {
    setFeatureFlag: (state, action: PayloadAction<FeatureFlag>) => {
      const { applicationName, configurationName, flagName, isEnabled } =
        action.payload;
      const foundFlag = state.flags.find(
        (flag) =>
          flag.applicationName === applicationName &&
          flag.configurationName === configurationName &&
          flag.flagName === flagName
      );
      if (foundFlag) {
        foundFlag.isEnabled = isEnabled;
      } else {
        state.flags.push(action.payload);
      }
    },
  },
});

export const { setFeatureFlag } = featureFlagSlice.actions;

export const featureFlagReducer = featureFlagSlice.reducer;

export const featureFlagSelector = (
  state: FeatureFlagState,
  applicationName: string,
  configurationName: string,
  flagName: string
) =>
  state.flags.find(
    (flag) =>
      flag.applicationName === applicationName &&
      flag.configurationName === configurationName &&
      flag.flagName === flagName
  );
